import { Toast, Image } from 'antd-mobile'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './index.css'
import { teamApi } from '../../features/team/api/teamApi'

export default function TeamList({ gameId }) {

    const [teamInfoList, setTeamInfoList] = useState([])

    const navigate = useNavigate()

    const getUserList = useCallback(() => {
        Toast.show({
            icon: 'loading',
        })
        teamApi.getList(gameId)
            .then(function (response) {
                setTeamInfoList(response.data.data)
            })
            .catch(function (error) {
                console.error('获取成员列表失败', error);
            })
            .finally(() => {
                Toast.clear()
            });
    }, [gameId])

    useEffect(() => {
        getUserList()
    }, [getUserList])


    return (
        <div className="team-list-wrapper">
            {teamInfoList && teamInfoList
                .sort((a, b) => {
                    if (Number(b.integral) !== Number(a.integral)) return Number(b.integral) - Number(a.integral);
                    if (Number(b.win) !== Number(a.win)) return Number(b.win) - Number(a.win);
                    return (Number(b.goal) - Number(b.lost)) - (Number(a.goal) - Number(a.lost));
                })
                .map((item, index) => (
                    <div key={index} className="team-card-item" onClick={() => {
                        localStorage.setItem("teamId", JSON.stringify(item))
                        navigate("/teamMember")
                    }}>
                        <div className="team-main-info">
                            <div className={`team-rank-badge rank-${index + 1}`}>
                                {index + 1}
                            </div>
                            {item.teamLogo ? <Image
                                src={item.teamLogo}
                                className="team-logo-small"
                                fit='cover'
                                width={32}
                                height={32}
                            /> : <div className="team-logo-small team-logo-name" title={item.teamName}>
                                {/* 外战队伍无队徽时显示名称简称，避免空图片图标。 */}
                                {item.teamName?.slice(0, 2) || '队'}
                            </div>}
                            <div className="team-name-full">{item.teamName}</div>
                            <div className="team-points-highlight">
                                <span>{item.integral || 0}</span>
                                <span className="team-points-label">PTS</span>
                            </div>
                        </div>

                        <div className="team-stats-bar">
                            <div className="stat-cell">
                                <span className="stat-cell-label">赛</span>
                                <span className="stat-cell-value">{item.total || 0}</span>
                            </div>
                            <div className="stat-cell">
                                <span className="stat-cell-label">胜</span>
                                <span className="stat-cell-value win">{item.win || 0}</span>
                            </div>
                            <div className="stat-cell">
                                <span className="stat-cell-label">平</span>
                                <span className="stat-cell-value">{item.draw || 0}</span>
                            </div>
                            <div className="stat-cell">
                                <span className="stat-cell-label">负</span>
                                <span className="stat-cell-value lose">{item.fail || 0}</span>
                            </div>
                            <div className="stat-cell">
                                <span className="stat-cell-label">得/失</span>
                                <span className="stat-cell-value">{item.goal || 0}/{item.lost || 0}</span>
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}
